"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentAssignmentVariantServiceResponse = void 0;
class TreatmentAssignmentVariantServiceResponse {
    constructor(assignmentContext, dataVersion, configs) {
        this.assignmentContext = assignmentContext;
        this.dataVersion = dataVersion;
        this.configs = configs;
        this.assignedVariants =
            TreatmentAssignmentVariantServiceResponse.getAssignedVariants(assignmentContext);
        this.featureVariables = this.configs;
        this.validUntil = new Date();
    }
    static getAssignedVariants(assignmentContext) {
        const assignedVariants = [];
        if (!assignmentContext) {
            return assignedVariants;
        }
        const parameterDelimiter = ';';
        const allocationDelimiter = ':';
        const flightAllocationsArray = assignmentContext.split(parameterDelimiter);
        for (const flightAllocationString of flightAllocationsArray) {
            if (!flightAllocationString)
                continue;
            const flightAllocationPair = flightAllocationString.split(allocationDelimiter, 2);
            switch (flightAllocationPair.length) {
                case 1:
                    assignedVariants.push({
                        name: flightAllocationPair[0],
                        variantAllocationId: -1,
                    });
                    break;
                case 2:
                    let variantAllocationId = Number(flightAllocationPair[1]);
                    if (!flightAllocationPair[1] || isNaN(variantAllocationId)) {
                        variantAllocationId = -1;
                    }
                    assignedVariants.push({
                        name: flightAllocationPair[0],
                        variantAllocationId: variantAllocationId,
                    });
                    break;
                default:
                    break;
            }
        }
        return assignedVariants;
    }
}
exports.TreatmentAssignmentVariantServiceResponse = TreatmentAssignmentVariantServiceResponse;
//# sourceMappingURL=TreatmentAssignmentVariantServiceResponse.js.map